const config = {
  routes: {
    label: 'Impressum',
    prefix: '/impressum',
  },
}

export default config
